import React from "react";
import { ReactComponent as DebitCard } from "src/components/SVGcomponents/card.svg";
import { ReactComponent as Bitcoin } from "src/components/SVGcomponents/Icon-Crypto.svg";
import { ReactComponent as InvoiceIcon } from "src/components/SVGcomponents/Icon-Invoice.svg";
import { AddFundModal } from "../AddFundModal/AddFundCardModal";
import { AddFundInvoiceModal } from "../AddFundModal/AddFundInvoiceModal";
import { AddFundByCryptoModal } from "../AddFundModal/AddFundCryptoModal";
import { PaymentOption } from "src/components/PaymentOption";
import { BasicModal } from "../BasicModal/BasicModal";
import styles from "./styles.module.scss";

type Props = {
  closeModal: () => void;
  isOpened: boolean;
};

const paymentOptions = [
  {
    icon: DebitCard,
    text: "Card",
    modal: AddFundModal,
    disabled: true,
  },
  {
    icon: Bitcoin,
    text: "Crypto",
    modal: AddFundByCryptoModal,
    disabled: true,
  },
  {
    icon: InvoiceIcon,
    text: "Invoice",
    modal: AddFundInvoiceModal,
    disabled: false,
  },
];

export const AddFundsModal = ({ closeModal, isOpened }: Props) => {
  return (
    <BasicModal
      sx={{ maxWidth: "700px" }}
      closeModal={closeModal}
      isOpened={isOpened}
      className={styles.addFundsModal}
    >
      <div>
        <h3 className={styles["title"]}>Add funds</h3>
        <p className={styles["text"]}>Select the top up method</p>
      </div>
      <div className={styles["payment-options-container"]}>
        {paymentOptions.map((option, index) => (
          <PaymentOption
            key={index}
            Icon={option.icon}
            text={option.text}
            Modal={option.modal}
            disabled={option.disabled}
          />
        ))}
      </div>
    </BasicModal>
  );
};
